type AvailableColors = 'coolGray5' | 'coolGray10';

export const AVAILABLE_TABLE_ROW_COLORS: Record<AvailableColors, string> = {
  coolGray10: 'Mui-selected-cool-grey-10',
  coolGray5: 'Mui-selected-cool-grey-5',
};

export const LEFT_COLUMN_NAME = 'leftPadding';
export const RIGHT_COLUMN_NAME = 'rightPadding';

export const PAGE_SIZE = 30;
export const SKELETON_ROWS_COUNT = 10;
export const INIT_SKELETON_ROWS_COUNT = 20;
export const DEFAULT_ROW_HEIGHT = 54;
